import { NewsLetterCard } from "./NewsLetterCard";
import useDashboard from "./useDashboard";
import { BomLeftSection } from "./BomLeftSection";

const Dashboard = () => {
  const { currentFinanceYear: _ } = useDashboard();
  return (
    <div className="p-4 md:p-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-[20px]">
        <div className="grid grid-cols-1 gap-[20px] md:col-span-3 h-fit">
          <BomLeftSection />
        </div>
        <NewsLetterCard />
      </div>
    </div>
  );
};

export default Dashboard;
